import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-camp-icon',
    templateUrl: './camp-icon.component.html',
    styleUrls: ['./camp-icon.component.scss'],
    standalone: false
})
export class CampIconComponent implements OnInit {

    @Input() public iconName: string;
    @Input() public size: string;

    constructor() { }

    ngOnInit() {
    }

    public categoryIconName() {
        if (!this.iconName) {
            return "size-30 fa fa-child";
        }

        var iconSize = this.size ? this.size : "40";

        return ("bc-icon-" + this.iconName).replace(/\s/g, '') + ' size-' + iconSize;
    }
}
